import Heading, { BaseHeading } from './Heading';
import type { BaseHeadingProps } from './Heading';

export * from './HeadingLevels';
export { BaseHeading };
export type { BaseHeadingProps };
export default Heading;
